<template>
    <div class="p-0 col-md-8 mx-auto" style="border: none!important;">
        <p class="mt-5">بسته موردنظر خود را با پرکردن تمامی فیلدهای درخواستی ایجاد کنید.</p>
        <v-row class="mt-5">
            <v-col cols="12" md="6">
                <v-text-field
                        v-model="title"
                        label="عنوان محصول"
                        required
                        counter="80"
                        maxLength="80"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        dense
                        outlined
                        class="mt-1"
                        prepend-inner-icon="fa fa-pencil-alt"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <admin-category ref="category" parent-name="دسته بندی"></admin-category>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-text-field
                        v-model="priceSeperator"
                        label="مبلغ"
                        outlined
                        @keypress="onlyNumber($event)"
                        required
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        dense
                        suffix="﷼"
                        prepend-inner-icon="fa fa-pencil-alt"
                        class="mt-1"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                        label="تخفیف"
                        v-model="discount"
                        :hint="'مبلغ نهایی با اعمال تخفیف : ' + ' ' + finalPriceCounter + '﷼'"
                        outlined
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        @keypress="onlyNumber($event)"
                        required
                        suffix="%"
                        dense
                        prepend-inner-icon="fa fa-pencil-alt"
                        class="mt-1"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <image-uploader limit="10"></image-uploader>
            </v-col>
            <v-col cols="12" md="6">
                <file-uploader></file-uploader>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-autocomplete label="نوع بانک اطلاعاتی" class="mt-1" outlined dense :items="banks"
                                v-model="bankType"
                                item-text="name"
                                prepend-inner-icon="fa fa-pencil-alt"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                        v-model="recordCount"
                        label="تعداد رکورد"
                        outlined
                        @keypress="onlyNumber($event)"
                        required
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        dense
                        prepend-inner-icon="fa fa-pencil-alt"
                        class="mt-1"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-switch
                v-model="country"
                label="کشوری"
                color="indigo"
        ></v-switch>
        <v-row v-if="country==false">
            <v-col cols="12" md="6">
                <province-selector ref="province"></province-selector>
            </v-col>

            <v-col cols="12" md="6">
                <city-selector ref="city"></city-selector>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-textarea
                        label="توضیحات"
                        v-model="description"
                        outlined
                        required
                        dense
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        rows="5"
                        prepend-inner-icon="fa fa-pencil-alt"
                        class="mt-1"
                ></v-textarea>
            </v-col>
        </v-row>
        <div class="col-md-12 text-left">
            <v-btn @click="createPack" class="mt-5 submit-btn">
                <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                ثبت تعرفه
            </v-btn>
        </div>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import AdminCategory from "../mainComponents/adminCategory";
import {Axios2, Bus} from "../../../main";
import ImageUploader from "../mainComponents/imageUploader";
import FileUploader from "../mainComponents/fileUploader";
import CitySelector from "../mainComponents/citySelector";
import ProvinceSelector from "../mainComponents/provinceSelector";

export default {
    name: "editPack",
    components: {ProvinceSelector, CitySelector, FileUploader, ImageUploader, AdminCategory, TitleRibbon},
    props: {
        infos: {
            require: true,
        }
    },
    data() {
        return {
            title: this.infos.title,
            recordCount: this.infos.count,
            category: this.infos.category,
            category_id: this.infos.category_id,
            description: this.infos.description,
            price: this.infos.amount,
            finalPrice: this.infos.finalPrice,
            discount: this.infos.discount,
            image: undefined,
            file: undefined,
            province: this.infos.province,
            city: this.infos.city,
            country: !this.infos.province && !this.infos.city,
            bankType: this.infos.type,
            banks: [
                {name: 'بانک اطلاعاتی شماره', value: 'phone'},
                {name: 'بانک اطلاعاتی معمولی', value: 'data'},
            ],
        }
    },
    methods: {
        createPack() {
            Axios2.put(`admin/archive/${this.infos.id}`, {
                "category_id": this.category_id,
                "province": this.province,
                "city": this.city,
                "title": this.title,
                "count": this.recordCount,
                "description": this.description,
                "amount": this.price,
                "discount": this.discount,
                "images": this.image,
                "file": this.file,
                "type": this.bankType
            }).then(() => {
                this.$modal.success('موفقیت‌ آمیز!', 'دسته موردنظر شما با موفقیت ویرایش شد.');
                Bus.$emit('resetValues', true);
                Bus.$emit("reload");
                this.modal();
            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            });
        },
    },
    computed: {
        priceSeperator: {
            set(value) {
                this.price = value.replaceAll(',', '');
            },
            get() {
                return this.$options.filters.currency(this.price);
            }
        },
        finalPriceCounter() {
            this.finalPrice = (this.price * this.discount) / 100;
            return this.$options.filters.currency(this.price - this.finalPrice);
        }
    },
    watch: {
        country(value) {
            if (!value) {
                this.$refs.province.province_id = this.infos.province;
                this.$refs.city.city_id = this.infos.city;
            } else {
                this.city = null;
                this.province = null;
            }
        }
    },
    mounted() {
        if (!this.country) {
            this.$refs.province.province_id = this.infos.province;
            this.$refs.city.city_id = this.infos.city;
        }
        this.$refs.category.parent_id = this.category;

        // Bus.$on('getCategory', (value) => {
        //     this.category = value;
        // });

        Bus.$on('getCategoryId', (value) => {
            this.category_id = value;
        });

        Bus.$on('getImage', (value) => {
            this.image = value;
        });

        Bus.$on('getFile', (value) => {
            this.file = value;
        });

        Bus.$on('getCity', (value) => {
            this.city = value;
        });

        Bus.$on('getProvince', (value) => {
            this.province = value;
        });
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 1.3rem !important;
}
</style>